import { render } from "./TenWeekOrdersProjection.vue?vue&type=template&id=d74af22a"
import script from "./TenWeekOrdersProjection.vue?vue&type=script&lang=ts"
export * from "./TenWeekOrdersProjection.vue?vue&type=script&lang=ts"
script.render = render

export default script